import type { SVGProps } from 'react'

const SvgFrequency = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' {...props}>
    <g fill={fill}>
      <path d='M4 21.028c-.283 0-.52-.096-.712-.287S3 20.31 3 20.027v-3c0-.283.096-.52.288-.712s.429-.288.712-.288.52.096.713.288.287.429.287.712v3c0 .283-.096.52-.287.713s-.43.287-.713.287m3.288-.287A.968.968 0 0 1 7 20.027v-3c0-.283.096-.52.288-.712s.429-.288.712-.288.52.096.713.288.287.429.287.712v3c0 .283-.096.52-.287.713s-.43.287-.713.287-.52-.096-.712-.287m4 0a.968.968 0 0 1-.288-.713v-3c0-.283.096-.52.288-.712s.429-.288.712-.288.52.096.713.288.287.429.287.712v3c0 .283-.096.52-.287.713s-.43.287-.713.287-.52-.096-.712-.287m4.712.287c-.283 0-.52-.096-.712-.287S15 20.31 15 20.027v-3c0-.283.096-.52.288-.712s.429-.288.712-.288h4c.283 0 .52.096.713.288s.287.429.287.712v3c0 .283-.096.52-.287.713s-.43.287-.713.287z' />
      <path
        fillOpacity={0.5}
        d='M3 13.025a.92.92 0 0 1 .304-.68l4.99-4.831c.358-.348.803-.522 1.334-.522s.976.174 1.335.522l2.413 2.336 5.996-6.555A.845.845 0 0 1 20.039 3c.273 0 .504.091.691.273a.848.848 0 0 1 .27.6.839.839 0 0 1-.246.624l-6.067 6.623a1.85 1.85 0 0 1-1.335.624 1.802 1.802 0 0 1-1.382-.533L9.628 8.943 4.71 13.706a.98.98 0 0 1-1.406 0 .921.921 0 0 1-.304-.68'
      />
    </g>
  </svg>
)

export default SvgFrequency
